import { useGetETSTicketsQuery } from 'gcs-common/clients/api/entities/tickets/tickets-api';
import {
  type ETSTicketsFilters,
  convertETSTicketsFiltersToQuery,
  useETSTicketsQueryParams,
} from 'gcs-common/clients/api/entities/tickets/tickets-api-helpers';
import { getCurrentUserId } from 'gcs-common/slices/currentUser/currentUserSelectors';
import { TicketDashboardTabNames } from 'gcs-common/slices/tickets/ticketsConstants';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import Select, { type StylesConfig } from 'react-select';
import styles from './styles.module.scss';

interface OptionType {
  value: string;
  label: string;
}

const CreatorFilter = () => {
  const { etsTicketsfilters, setETSTicketsQueryParams } = useETSTicketsQueryParams();
  const currentUserId: string = useSelector(getCurrentUserId);
  const [resetCreator, setResetCreator] = useState(false);

  useEffect(() => {
    if (!etsTicketsfilters.creatorId && etsTicketsfilters.tab !== TicketDashboardTabNames.NOT_LISTED) {
      setETSTicketsQueryParams(
        {
          creatorId: currentUserId,
        },
        false,
      );
    }
  }, []);

  const { creatorId } = etsTicketsfilters;
  const { data: ticketsData, isSuccess } = useGetETSTicketsQuery({
    query: convertETSTicketsFiltersToQuery(etsTicketsfilters),
  });

  const data = ticketsData ? ticketsData.data : undefined;
  const creators = ticketsData ? ticketsData.creators : [];
  const loaded = creators.length > 0;

  useEffect(() => {
    // if the current creator has no tickets, remove the creator from the filters so other tickets show up
    if (isSuccess && !resetCreator && etsTicketsfilters.creatorId && (!data || data.length === 0)) {
      setResetCreator(true);
      setETSTicketsQueryParams({
        creatorId: 'None',
      });
    }
  }, [isSuccess]);

  const creatorsOptions = creators.map((el) => ({
    label: el.friendlyName,
    value: el.id,
  }));

  const handleChange = (creator: ETSTicketsFilters['creatorId']) => {
    setETSTicketsQueryParams({
      creatorId: creator || 'None',
    });
  };

  const customStyles: StylesConfig<OptionType> = {
    container: (provided) => ({
      ...provided,
      width: '100%',
    }),
    control: (provided) => ({
      ...provided,
      borderRadius: '8px',
    }),
    menu: (provided) => ({
      ...provided,
      borderRadius: '8px',
    }),
  };

  return (
    <div className={styles.creatorSelectContainer}>
      <Select<OptionType>
        /** Force re-render when options are loaded to update defaultValue. */
        key={(loaded ? 'true' : 'false') + etsTicketsfilters.creatorId}
        name="ticketCreatorId"
        options={creatorsOptions}
        defaultValue={creatorsOptions.find((x) => x.value === creatorId)}
        isClearable
        onChange={(selectedOption) => handleChange(selectedOption?.value || undefined)}
        styles={customStyles}
        placeholder="Ersteller"
        value={creatorsOptions.find((x) => x.value === creatorId)}
      />
    </div>
  );
};

export default CreatorFilter;
